import { render, staticRenderFns } from "./SensorDetails.vue?vue&type=template&id=1c5da4fa&scoped=true&"
import script from "./SensorDetails.vue?vue&type=script&lang=js&"
export * from "./SensorDetails.vue?vue&type=script&lang=js&"
import style0 from "./SensorDetails.vue?vue&type=style&index=0&id=1c5da4fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5da4fa",
  null
  
)

export default component.exports